import { Divider, Grid } from '@mui/material';
import { WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

import SMTPEmailFilter from '../../../../components/filters/components/SMTPEmailFilter';
import CardWrapper from '../../childRoutes/CardWrapper';
import { CampaignHeader, DuretionInput, SectionHeaders } from '../../components';

import { EmailCampaignSettingCardProps } from './CandidateRulesCard';

const SendEmailRuleCard = ({ onReset, onSave }: EmailCampaignSettingCardProps) => (
  <CardWrapper>
    <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
      Sender and Campaign Controls
    </WsTypography>
    <Grid p={2} display="flex" direction="column" rowGap={1.5}>
      <SectionHeaders
        title={'Sender Email'}
        subTitle={'All campaign emails will be sent from this address.'}
      />
      <Grid xs={4} display="flex" direction="column" rowGap={1}>
        <WsTypography>Email Address *</WsTypography>
        <SMTPEmailFilter name="senderEmail" />
      </Grid>
      <Divider />
      <CampaignHeader name="followUpEmailCheck" skip={true}>
        <WsTypography variant={WsTypoVariants.BODY1} bold>
          Allow Follow-up Email
        </WsTypography>
      </CampaignHeader>
      <DuretionInput
        tagLine="Send follow-up after"
        durationName="followUpEmail"
        timeSpanName="followUpEmailDuration"
      />
      <Grid display="flex" justifyContent="flex-end" columnGap={2}>
        <WsButton variant="outlined" onClick={onReset}>
          Discard
        </WsButton>
        <WsButton onClick={onSave}>Save</WsButton>
      </Grid>
    </Grid>
  </CardWrapper>
);
export default SendEmailRuleCard;
